// checkout.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCheckoutUrl(ndd: string, priceId: string): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(
      this.apiUrl + '/api/checkout',
      { ndd: ndd, priceId: priceId },
      { withCredentials: true }
    );
  }
}
